import React from 'react';
import './navbar.css';
import {Link} from 'react-router-dom';
import { useSelector, useDispatch} from 'react-redux';
import { Redirect } from 'react-router-dom';
import 'animate.css'

function Navbar({nome}){

    const dispatch = useDispatch();

    return(
        
        <nav className="navbar">
            {useSelector(state => state.usuarioLogado) === 0 ? <Redirect to='/' /> : null}            
                {           
                    useSelector(state => state.usuarioEmail) === "sistemadeltario@gmail.com" ?                  
                <>
                    <div className="nav-bar">   
                        <Link className="nav-link" to="/home"><i className="bi bi-house-door"></i></Link>
                        <Link className="nav-link" to="/registro-de-documento"><i className="bi bi-file-earmark-arrow-up"></i></Link>
                        <Link className="nav-link" to="/registro-seguro"><i className="bi bi-person-plus"></i></Link>
                        <Link className="nav-link" onClick={() => dispatch({type: 'LOG_OUT'})   }><i className="bi bi-box-arrow-left"></i></Link>
                    </div>  
                </>
                :
                <>   
                    <div className="nav-bar">   
                        <Link className="nav-link" to="/home"><i className="bi bi-house-door"></i></Link> 
                        <Link className="nav-link" onClick={() => dispatch({type: 'LOG_OUT'})   }><i className="bi bi-box-arrow-left"></i></Link>
                    </div>                   
                </>
                }                    
        </nav>
    )
}

export default Navbar;